/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable no-unsafe-optional-chaining -- needed */
/* eslint-disable consistent-return -- needed */
import {
  Button,
  Checkbox,
  ComponentLevelNotification,
  Heading,
  SelectNative,
  SelectNativeOption,
} from '@americanexpress/dls-react';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import CardMemberInfo from '../../CardMemberInfo';

import {
  getEndpoint,
  getEnrollmentRequestBody,
} from '../../../../../api/api-utils';
import { CreateLoyaltyBenefitEnrollmentStatusVx } from '../../../../../constants';
import useDisableButton from '../../../../../hooks/useDisableButton';
import useOneData from '../../../../../hooks/useOneData';
import { renderHTML } from '../../../../../utilities/render-html';
import { Layout } from '../layout';

export function SelectListApply(props) {
  const selectionLabel = props?.selectionLabel;
  const selections = props?.selections || [];
  const defaultLabel = {
    value: null,
    label: selectionLabel,
    element: selectionLabel,
  };
  const [checkbox, toggleCheckBox] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultLabel);
  const [agreeError, setAgreeError] = useState(false);
  const [invalidSelectError, setInvalidSelectError] = useState(false);
  const intl = useIntl(); // Hook for accessing locale content, intl.formatMessage()
  const stepTransition = props.stepTransition;
  const selectedProduct = props.selectedProduct;
  const layoutType = props.layoutType;
  const subscriptionId = props?.subscriptionId;
  const { isFetching, error, data } = props?.cardData;
  const languageData = props?.languageData;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  const formattedSelections = () => {
    // eslint-disable-next-line array-callback-return -- needed
    const formatSelections = selections.map((selection) => {
      const value = selection?.code;
      const label = selection?.name;
      const element = selection?.name;
      const hasSelection = value && label;

      if (hasSelection) {
        return { value, label, element };
      }
    });

    formatSelections.unshift(defaultLabel);
    return formatSelections;
  };

  const label = props.callToAction?.INTERNAL.label || props.callToAction?.ANCHOR?.label || 'Enroll Now';
  const title = props?.title;
  const description = props?.description;
  const safeTitle = renderHTML(title);
  const safeDescription = renderHTML(description);

  const faasApiUrl = props?.faasApiUrl;
  const sorBenefitId = props.sorBenefitId;
  const benefitName = props.benefitName;
  const cardname = props.cardname;
  const benefitTitle = props?.benefitTitle;
  const locale = props?.locale;
  const endpoint = getEndpoint(
    faasApiUrl,
    CreateLoyaltyBenefitEnrollmentStatusVx
  );
  const requestOptions = {
    selectionCode: selectedItem.value,
    benefitName,
    cardname,
    layoutType,
    subscriptionId,
  };
  const requestBody = getEnrollmentRequestBody(
    selectedProduct,
    sorBenefitId,
    locale,
    requestOptions
  );
  const endpointOptions = {
    body: requestBody,
    defer: true, // defers fetchye call until run function is invoked
  };
  const { isLoading, run } = useOneData(endpoint, endpointOptions);
  const { isDisabledAfterSubmit, disableButton } = useDisableButton();

  const submit = async () => {
    const isValidSelection = selectedItem && selectedItem.value !== selectionLabel;
    const isValidSubmit = checkbox && isValidSelection;
    const showAgreeError = !checkbox;
    const showInvalidSelectError = !isValidSelection;

    if (showAgreeError) {
      return setAgreeError(true);
    }

    if (showInvalidSelectError) {
      return setInvalidSelectError(true);
    }

    if (isValidSubmit) {
      setAgreeError(false);
      setInvalidSelectError(false);
      disableButton();
      const { data: enrollmentSuccess, error: enrollmentError } = await run();
      if (enrollmentSuccess) {
        stepTransition(true, false);
      }
      if (enrollmentError) {
        stepTransition(false, true);
      }
    }
  };

  const onChangeDropDown = async (e) => {
    setSelectedItem(e.target);
    setInvalidSelectError(false);
  };

  const onChangeCheckbox = async () => {
    if (!checkbox) {
      if (agreeError) {
        setAgreeError(false);
      }
      toggleCheckBox(true);
    } else {
      toggleCheckBox(false);
    }
  };

  return (
    <>
      <section className="text-justify">
        <Heading level={2} variant="sans-small-regular" className="text-align-center margin-0 margin-3-b pad-0">
          {safeTitle}
        </Heading>
        {safeDescription && <article className="margin-3-b">{safeDescription}</article>}
      </section>
      <Layout>
        {!isFetching && !error && (
          <CardMemberInfo {...data} languageData={languageData} />
        )}
        <section className="margin-t">
          <SelectNative
            id="dropdown-selection"
            label={selectionLabel}
            className="margin-2-b"
            onChange={onChangeDropDown}
            data-testid="selectlist-dropdown"
          >
            {formattedSelections().map((item) => (
              <SelectNativeOption key={item.value} value={item.value}>
                {item.label}
              </SelectNativeOption>
            ))}
          </SelectNative>
          {intl.formatMessage({
            id: 'hide-ui.tnc-checkbox',
            defaultMessage: '',
          }) === 'true'
            ? ''
            : (
              <Checkbox
                id="enrollment-checkbox"
                label={`${intl.formatMessage({ id: 'shared.terms-links.terms-and-conditions', defaultMessage: 'I understand and agree to the terms and conditions.‡' })}`}
                reactlytics={{
                  element: `${cardname}>>${benefitName}>>agree-to-terms`,
                }}
                onChange={onChangeCheckbox}
              />
            )}
        </section>
        {agreeError && (
        <ComponentLevelNotification className="pad-2-t">
          Please read and agree to the Terms & Conditions.
        </ComponentLevelNotification>
        )}
        {invalidSelectError && (
        <ComponentLevelNotification className="pad-2-t">
          <p>Please make a selection from the dropdown.</p>
        </ComponentLevelNotification>
        )}
        <ExtendReactlytics
          analytics={{
            event: {
              meta: {
                benefitname: `${parseEntities(benefitTitle)?.replace(/ /g, '-').toLowerCase()}`,
              },
            },
          }}
        >
          <Button
            id="enrollsubmit"
            className="width-full flex flex-column flex-align-items-center margin-auto-lr margin-2-t margin-1-b"
            reactlytics={{
              element: `cta>>enroll-submit>>${cardname?.replace(/ /g, '-').toLowerCase()}`,
              type: 'impression',
            }}
            onClick={submit}
            working={isLoading}
            isDisabled={isDisabledAfterSubmit}
            aria-label={`${`${intl.formatMessage({ id: label })} ${benefitName}`}`}
            variant="primary"
          >
            {intl.formatMessage({
              id: `shared.terms-links.${label.replace(/ /g, '-').toLowerCase()}`,
              defaultMessage: label,
            })}
          </Button>
        </ExtendReactlytics>
      </Layout>
    </>
  );
}
